import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AttachmentsService {

    constructor(
        private http: HttpClient,
    ) {}

    saveModelAttachments(modelId: any, modelName: any, file: File, status: any, attachmentOrder: any, viewType: any, idNumber: any = '', lang: String = '', replaceFile: boolean = false, attachmentId = '', currentUserId: any = '', identification_type: Number = null, expiration_date: String = '', selfAssessedRiskKey: string = ''): Observable<any> {
        const formData: any = new FormData();
        formData.append('id', modelId);
        formData.append('file', file);
        formData.append('attachmentOrder', attachmentOrder);
        formData.append('language', lang);
        formData.append("expiration_date", expiration_date)

        if(replaceFile && attachmentId){
            formData.append('replaceFile', replaceFile);
            formData.append('attachmentId', attachmentId);
        }
        if (modelName === 'tickets-attachments') {
            formData.append('modelName', 'tickets_documents');
            formData.append('internal_attachment', status);
            formData.append('user_id', currentUserId);
            return this.http.post(environment.yiiUrl + 'tickets-attachments/uploader', formData);
        }
        if (modelName === 'cms_medias') {
            formData.append('modelName', modelName);
            return this.http.post(environment.yiiUrl + 'cms-medias/uploader', formData);
        }
        if(modelName == 'commercial_auction'){
            formData.append('identification_number',idNumber) ;
            formData.append('identification_type',modelName) ;
            formData.append('language',lang) ;
            formData.append('created_by', currentUserId);
        }
        if (viewType === 'propertyDocuments' || viewType === 'documents') {
            formData.append('document', true);
        }
        formData.append('modelName', modelName);
        if(identification_type){
            formData.append('identification_type', identification_type);
        }
        if (modelName === 'comments' && selfAssessedRiskKey) {
            formData.append('self_assessed_risk_key', selfAssessedRiskKey);
        }
        return this.http.post(environment.yiiUrl + 'attachments/uploader', formData);
    }

    // upload attachment/s (nodeJs + s3)
    uploadAttachments(model: string, id: string, files: File | File[]): Observable<any> {
        const formData = new FormData();
        if (Array.isArray(files)) {
            files.forEach(file => formData.append('files', file));
        } else {
            formData.append('files', files); // single file
        }
        const url = `${environment.apiUrl}attachments/uploader/${model}/${id}`;
        return this.http.post(url, formData);
    }

    saveAttachmentData(data){
        return this.http.post(environment.yiiUrl + 'attachments/save-attachment-data', data);
    }

    unlinkAttachment(data){
        return this.http.post(environment.yiiUrl + 'attachments/unlink-attachment', data);
    }

    mailAttachment(file: File): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'emails/mail-attachment', formData);
    }

    getModelAttachments(id: any, modelName: any, documentKey = "", from_portal = false, sort_by = 'order'): Observable<any> {
        if (documentKey !== '' && documentKey !== undefined) { // should not ignore false
            return this.http.get(environment.yiiUrl + `attachments/get-attachments?id=${id}&modelName=${modelName}&documentKey=${documentKey}&from_portal=${from_portal}&sort_by=${sort_by}&expand=document_key`);
        } else {
            return this.http.get(environment.yiiUrl + `attachments/get-attachments?id=${id}&modelName=${modelName}&from_portal=${from_portal}&sort_by=${sort_by}&expand=document_key`);
        }
    }

    getAllDocuments(data: any, page: any, perPage: any, selectRecords: boolean = false): Observable<any> {
        const selectRecordsParam = selectRecords ? '&selectRecords=true' : '';
        return this.http.post(environment.yiiUrl + `attachments/get-all-documents?per-page=${perPage}&page=${page}&expand=document_key,model_data,created_by_data${selectRecordsParam}`, data, { observe: 'response' as 'body' });
    }
    // Nodejs + s3
    getAttachments(payload: any): Observable<any> {
        return this.http.post(environment.apiUrl + 'attachments/get-attachments', payload);
    }
    // Get counts of attachments for multiple model IDs
    getAttachmentCounts(modelIds: string[], modelName: string): Observable<any> {
        const payload = {
            query: { model_id: { $in: modelIds }, model_name: modelName },
            options: { limit: 1000, select: 'model_id' }
        };
        return this.getAttachments(payload);
    }
    getPaginatedModelAttachments(id: any, modelName: any, perPage: any, page: any): Observable<any> {
        // tslint:disable-next-line: max-line-length
        return this.http.get(environment.yiiUrl + `attachments/get-paginated-attachments?id=${id}&modelName=${modelName}&expand=document_key&page=${page}&per-page=${perPage}`, { observe: 'response' as 'body' });
    }
    getPropertiesAttachments(id: any): Observable<any> {
        return this.http.get(environment.yiiUrl + `properties/get-attachments?p_id=${id}`);
    }

    getDossierContracts(id: any): Observable<any> {
        return this.http.get(environment.apiUrl + `dossier/get-contracts?dossier_id=${id}`);
    }

    getDossierAttachments(dossierId: string, page: number = 1, perPage: number = 10): Observable<any> {
        return this.http.get(
            environment.yiiUrl + `attachments/get-dossier-attachments?id=${dossierId}&expand=document_key&page=${page}&per-page=${perPage}`,
            { observe: 'response' as 'body' }
        );
    }

    getDossierAttachmentsIds(dossierId: string): Observable<any> {
        return this.http.post(
            environment.yiiUrl + `attachments/get-all-documents?selectRecords=true`,
            { dossier_id: dossierId },
            { observe: 'response' as 'body' }
        );
    }

    getTicketsAttachments(id: any): Observable<any> {
        return this.http.get(environment.yiiUrl + `tickets-attachments/get-attachments?id=${id}&modelName=tickets_documents`);
    }

    saveCompaniesCSV(file: File, _id: string): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'xml-export-formats/csv-company-uploader?user=' + _id, formData);
    }

    saveContactsCSV(file: File, user: string, company: string): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'xml-export-formats/csv-contacts-uploader?user=' + user + '&company=' + company, formData);
    }

    saveOwnersCSV(file: File, _id: string): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'xml-export-formats/csv-owner-uploader?user=' + _id, formData);
    }

    saveTimelineCSV(file: File, _id: string): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'xml-export-formats/csv-timeline-uploader?user=' + _id, formData);
    }

    deleteAttachment(id: any, nodejs: boolean = false): Observable<any> {
        const baseUrl = nodejs ? environment.apiUrl : environment.yiiUrl;
        return this.http.delete(`${baseUrl}attachments/${id}`);
    }

    deleteSelection(data: any): Observable<any> {
        return this.http.post(
            environment.yiiUrl + 'attachments/delete-selection',
            data,
        );
    }

    deleteCmsMedia(id: any, file: any): Observable<any> {
        return this.http.delete(`${environment.yiiUrl}cms-medias/delete-attachment?model_id=${id}&file_name=${file}`);
    }

    updateAttachment(data: any): Observable<any> {
        return this.http.put(`${environment.yiiUrl}attachments/${data._id}`, data);
    }

    uploadSingle(madelId: any, modelName: any, file: File): Observable<any> {
        const formData: any = new FormData();
        formData.append('id', madelId);
        formData.append('modelName', modelName);
        formData.append('type', 'logo');
        formData.append('file', file);
        return this.http.post(`${environment.yiiUrl}users/upload-single`, formData);
    }

    uploadTranslations(file: File): Observable<any> {
        const formData: any = new FormData();
        formData.append('file', file);
        return this.http.post(environment.yiiUrl + 'translations/uploade-translations', formData);
    }
    copyAttachments(from: any, to: any): Observable<any> {
        return this.http.get<any[]>(`${environment.yiiUrl}attachments/copy-attachment?from_id=${from}&to_id=${to}`);
    }

    getCmsMedia(id: any, model: any, page: any): Observable<any> {
        return this.http.get<any[]>(`${environment.yiiUrl}cms-medias/get-cms-medias?id=${id}&modelName=${model}&page=${page}`, { observe: 'response' as 'body' });
    }

    getImageURL(model: string, id: string, imageName: string): string {
        const s3Url = environment?.s3Url ? environment.s3Url : '';
        return `${s3Url}${model}/${id}/${imageName}`;
    }

    bulkDownload(ids: string[]): Observable<any> {
        return this.http.post(`${environment.apiUrl}attachments/bulk-download`, { ids }, { responseType: 'blob' });
    }
}
